import { useContext, useEffect } from "react";
import TimelineItem from "types/TimelineItem";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import getTimelinePositions from "../utils/getTimelinePositions";
import getTimelinePositionsDuration from "../utils/getTimelinePositionsDuration";

export default function useInitializeTimelinePlayer(
  timelineItems: TimelineItem[],
  initiallyPlaying: boolean,
) {
  const { setPlaying, setTimelinePositions, setTotalDuration } = useContext(
    TimelinePlayerContext,
  );
  const itemsKey = JSON.stringify(timelineItems);

  useEffect(() => {
    const items = JSON.parse(itemsKey) as TimelineItem[];
    if (items.length === 0) return;
    const timelinePositions = getTimelinePositions(items);
    setTotalDuration(getTimelinePositionsDuration(timelinePositions));
    setTimelinePositions(timelinePositions);
  }, [itemsKey, setTimelinePositions, setTotalDuration]);

  useEffect(() => {
    setPlaying(initiallyPlaying);
  }, [initiallyPlaying, setPlaying]);
}
